import createCrtcreatorEntityStore from './createEntityStore'

export default createCrtcreatorEntityStore({
  endpoint: 'api/modules/crtcreator/content-categories',
})
